module.exports = __webpack_public_path__ + "static/media/webhookEditInPortal.acfdb584.png";